module.exports = __webpack_public_path__ + "media/images/webpage/hotels/4460/floorguide/course-1-photo-11-4034b03d888efbc9efbe253b1eed11f0.webp";